import '../../libs/jquery.maskedinput-master/src/jquery.maskedinput';

$(function(){
	initPhoneMask();
});

function initPhoneMask(){
	$('input[type=phone]').mask('+38 (099) 999-99-99');
}